<template>
    <div class="bg-body-div bg-color">
        <div v-show="false && JSON.stringify(detailData)==='{}'" class="flex jus-con-center ali-ite-center" style="width:100vw;height:100vh;">
            <div class="flex jus-con-center ali-ite-center" style="border-radius:1em;background-color:#FFFFFF;width:calc( 100vw - 20px );height: calc( 100vh - 20px );">
            <van-loading  color="#3377FF" />
            </div>
        </div>
        <div v-show="true || JSON.stringify(detailData)!=='{}'" class="flex padding-top-15 jus-con-center">
            <div class="padding-15" style="border-radius:1em;background-color:#FFFFFF;width:calc( 100vw - 50px );height: calc( 100vh - 100px );">
                <div>
                    <div class="order-order-no">
                        {{detailData.orderNo}}
                    </div>
                    <div class="margin-15 order-product-name">
                        {{detailData.productName}}
                    </div>
                    <div v-for="(ele, index) in refundRooms" :key="index">
                        <div class="flex ali-ite-center refund-room-ele jus-con-between">
                            <div>
                            <div class="refund-room-name">{{ele.roomName}}</div>
                                <div class="flex refund-room-passenger-name">
                                    入住人：<div>{{ele.checkInPerson}}</div>
                                </div> 
                            </div>
                            <div>
                                <van-checkbox v-model="ele.isChecked" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="margin-top-20 font-size-14">
                    <div>退票原因<div class="display-inline font-size-12">（必填）</div></div>
                    <van-field
                        v-model="applyRefundParams.reason"
                        rows="2"
                        autosize
                        label=""
                        type="textarea"
                        placeholder="请输入退票原因"
                        class="reason-in-field"
                    />
                </div>
            </div>
        </div>
        <div class="flex bottom-fixed-div jus-con-between">
            <div class="btn-div-k" style="width:50%;margin-right:1em;" @click="handleRefundRoom">确认退票</div>
            <div class="btn-div-k btn-div" style="width:50%;margin-right:1em;" @click="handleBack">不退了</div>
        </div>
    </div>
</template>
<script>
import { Notify, Toast } from 'vant';
export default {
    data() {
        return {
            id: '',
            detailData: {},
            refundRooms: [],
            applyRefundParams: {
                roomNos: [], // 房间列表
                reason: '', // 退票原因
            }
        }
    },
    created() {
        this.id = this.$route.query.id || '';
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.$API.cruise.getOrderDetail(this.id)
            .then(res => {
                if (res.code === 200) {
                    this.detailData = res.data;
                    this.$API.cruise.orderRefundRooms(res.data.orderNo).then(response => {
                        if (response.code === 200) {
                            this.refundRooms = (response.data.roomList || []).map(item => {
                                return {
                                    ...item,
                                    isChecked: false
                                }
                            });
                            console.log(this.refundRooms, 'vvvvvvvvv')
                        } else {
                            this.refundRooms = []
                        }
                    }).catch(error => {
                        this.refundRooms = []
                    })
                } else {
                    this.detailData = {}
                }
            }).catch(error => {
                this.detailData = {}
            })
        },
        handleRefundRoom() {
            var tempRoomKeys = this.refundRooms.filter((item) => {
                return item.isChecked === true
            }).map(ite => ite.roomKey)
            if (tempRoomKeys.length === 0) {
                Notify('请选择申请退单的房间')
                return
            };
            console.log(tempRoomKeys, 'tempRoomKeys')
            this.applyRefundParams.roomNos = tempRoomKeys;
            if (!this.applyRefundParams.reason) {
                Notify('请输入退票原因')
                return
            };
            this.$API.cruise.refundOrdersRooms(this.detailData.orderNo, this.applyRefundParams).then(res => {
                if (res.code === 200) {
                   Toast('退单成功');
                   this.handleBack();
                }
            })
        },
        handleBack() {
            this.$router.go(-1);
        },
    }
}
</script>
<style scoped>
@import "../../lib/flex-list.css";
.flex {
    display: flex;
}
.padding-top-15 {
    padding-top: 15px;
}
.jus-con-center {
    justify-content: center;
}
.ali-ite-center {
    align-items: center;
}
.jus-con-between {
    justify-content: space-between;
}
.bg-color{
        background-color: #F4F6F9;
    }
.bg-body-div{
    background-image: url("../../assets/flights/bg-img.png");
    background-repeat: no-repeat;
    background-size: 100%;
    padding-bottom:55px;
}
.top-div{
    width:100%;
    padding: 15px 25px 0 25px;
    box-sizing: border-box;
}
.padding-15 {
    padding: 15px;
}
.margin-15 {
    margin: 15px 0px;
}
.border-div{
    width: calc( 100% - 20px );
    box-sizing: border-box;
    margin:10px 10px 0 10px;
    padding:20px 15px;
    border-radius: 6px;
    background:#FFFFFF;
}
.order-order-no {
    font-size: 0.875em;
    color: #999999;
}
.order-product-name {
    color: #333333;
}
.refund-room-name{
    font-size: 0.875em;
    margin-bottom: 8px;
}
.refund-room-passenger-name{
    font-size: 0.75em;
    color: #999999;
}
.refund-room-ele {
    padding: 5px 0px 20px 0px;
    border-bottom: 1px solid #E7EBF3;
}
.display-inline {
    display: inline-block;
}
.bottom-fixed-div{
    width:100%;
    padding:5px 10px ;
    box-sizing: border-box;
    background: #FFFFFF;
    position: fixed;
    left:0;
    bottom:0;
    padding-bottom: 5px;
}
.btn-div-k,.btn-div{
    height: 32px;
    border-radius: 4px;
    border: 1px solid #3377FF;
    font-size: 13px;
    color: #3377FF;
    display: flex;
    justify-content: center;
    align-items: center;
    padding:0 0.5rem;
}
.btn-div{
    color:#FFFFFF;
    background: #3377FF;
}
.margin-top-20 {
    margin-top: 20px;
}
.font-size-14 {
    font-size: 0.875em;
}
.font-size-12 {
    font-size: 0.75em;
}
.reason-in-field {
  padding: 13px;
  background-color: #F4F6F9;
  margin-top: 15px;
}
</style>